import amplifyConfig from './amplify-config';
import { Auth } from '@aws-amplify/auth';
import { Storage } from '@aws-amplify/storage';

Auth.configure(amplifyConfig.Auth);
Storage.configure(amplifyConfig.Storage);